import { HTMLProps } from "react";
import cn from "classnames";
import { CircularProgress } from "@mui/material";

import styles from "./Loading.module.css";
import Delayed from "../Delayed";

export interface Props extends HTMLProps<HTMLDivElement> {
  initialDelayMs?: number;
}

export default function Loading({
  initialDelayMs = 750,
  className,
  children,
  ...etc
}: Props) {
  return (
    <div className={cn(styles.Loading, className)} {...etc}>
      <Delayed byMs={initialDelayMs}>
        <CircularProgress />
        {children && <div>{children}</div>}
      </Delayed>
    </div>
  );
}
